export default {
  diffServerTime: (state, getters, rootState, rootGetters) => {
    return state.diffServerTime
  },
  isOpenRollBook: (state, getters, rootState, rootGetters) => {
    return state.isOpenRollBook
  },
  isOpenVoiceRequest: (state) => { return state.isOpenVoiceRequest },
  isOpenControlMenu: (state, getters, rootState, rootGetters) => {
    return state.isOpenControlMenu
  }
}
